import React, { useState } from 'react';
import wingitDesign from '../designSystem';

export default function WingitPanel({ children, style = {} }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...wingitDesign.publicPages.panel,
        transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
        borderColor: hovered ? 'rgba(85,199,255,0.24)' : 'rgba(85,199,255,0.14)',
        boxShadow: hovered
          ? '0 18px 42px rgba(0,0,0,0.30)'
          : '0 10px 24px rgba(0,0,0,0.18)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}